import {useState, useRef} from "react";
import {Flex} from "@mantine/core";
import UserInput from "../sliceChatComponents/UserInput";
import IconArrowRight from "../../../assets/arrow-right.svg?react";
// Contextual suggestions temporarily disabled
// import {
//     ContextualSuggestionsDropdown,
//     ContextualSuggestionsDropdownHandle,
// } from "./ContextualSuggestionsDropdown";
import {CommandInput} from "./CommandInput";

interface SplashInputProps {
    onSendMessage: (value: string) => void;
    onValueChange: (value: string) => void;
    value?: string;
}
export const SplashInput = ({
    onSendMessage,
    onValueChange,
    value,
}: SplashInputProps) => {
    // Contextual suggestions temporarily disabled
    // const dropdownRef = useRef<ContextualSuggestionsDropdownHandle>(null);

    const handleSubmit = () => {
        if (!value || value.trim() === "") {
            return;
        }

        onSendMessage(value);
        onValueChange("");
    };

    // Contextual suggestions temporarily disabled
    // const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    //     // Pass keyboard events to the dropdown
    //     dropdownRef.current?.handleKeyDown(event);
    // };

    // const handleSuggestionSelect = () => {
    //     // Clear the input when a suggestion is selected
    //     onValueChange("");
    // };

    return (
        <Flex direction="column" pos="relative">
            <CommandInput
                variant="splash"
                disabled={false}
                onChange={onValueChange}
                onSendMessage={handleSubmit}
                // onKeyDown={handleKeyDown}
            />
            {/* Contextual suggestions temporarily disabled */}
            {/* <ContextualSuggestionsDropdown
                ref={dropdownRef}
                query={value || ""}
                onSuggestionSelect={handleSuggestionSelect}
            /> */}
        </Flex>
    );
};
